var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.item.image),expression:"item.image"}],staticClass:"image text-block"},[(!_vm.item.image)?_c('app-icon',{staticClass:"image-missing",attrs:{"icon":"noimage"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }